// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressToJSON,
    SexType,
    SexTypeFromJSON,
    SexTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportUpdatePatientPayload
 */
export interface SupportUpdatePatientPayload {
    /**
     * External system id of the patient
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUpdatePatientPayload
     */
    externalId?: string;
    /**
     * Individual nickname
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUpdatePatientPayload
     */
    nickname?: string;
    /**
     * Individual first name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUpdatePatientPayload
     */
    first: string;
    /**
     * Individual middle name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUpdatePatientPayload
     */
    middle?: string;
    /**
     * Individual last name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUpdatePatientPayload
     */
    last: string;
    /**
     * Individual suffix
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUpdatePatientPayload
     */
    suffix?: string;
    /**
     * The addresses
     * OpenAPI data type: {array}
     * @type {Array<Address>}
     * @memberof SupportUpdatePatientPayload
     */
    addresses?: Array<Address>;
    /**
     * Pregnant
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportUpdatePatientPayload
     */
    pregnant?: boolean;
    /**
     * The date of birth
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportUpdatePatientPayload
     */
    dob: string;
    /**
     * The date of death
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportUpdatePatientPayload
     */
    dod?: string;
    /**
     * 
     * OpenAPI data type: {SexType}
     * @type {SexType}
     * @memberof SupportUpdatePatientPayload
     */
    sex: SexType;
    /**
     * Individual weight in lbs
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof SupportUpdatePatientPayload
     */
    weight?: number;
    /**
     * Phone number
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportUpdatePatientPayload
     */
    phones?: Array<string>;
    /**
     * Email addresses
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportUpdatePatientPayload
     */
    emails?: Array<string>;
    /**
     * Occupation
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportUpdatePatientPayload
     */
    occupation?: string;
    /**
     * A patient authorization on file with provider to release medical information
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportUpdatePatientPayload
     */
    release?: boolean;
}

export function SupportUpdatePatientPayloadFromJSON(json: any): SupportUpdatePatientPayload {
    return {
            'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
            'nickname': !exists(json, 'nickname') ? undefined : json['nickname'],
            'first': json['first'],
            'middle': !exists(json, 'middle') ? undefined : json['middle'],
            'last': json['last'],
            'suffix': !exists(json, 'suffix') ? undefined : json['suffix'],
            'addresses': !exists(json, 'addresses') ? undefined : (json['addresses'] as Array<any>).map(AddressFromJSON),
            'pregnant': !exists(json, 'pregnant') ? undefined : json['pregnant'],
            'dob': json['dob'],
            'dod': !exists(json, 'dod') ? undefined : json['dod'],
            'sex': SexTypeFromJSON(json['sex']),
            'weight': !exists(json, 'weight') ? undefined : json['weight'],
            'phones': !exists(json, 'phones') ? undefined : json['phones'],
            'emails': !exists(json, 'emails') ? undefined : json['emails'],
            'occupation': !exists(json, 'occupation') ? undefined : json['occupation'],
            'release': !exists(json, 'release') ? undefined : json['release'],
    };

}

export function SupportUpdatePatientPayloadToForm(value?: SupportUpdatePatientPayload): any {
    let jsonVal = SupportUpdatePatientPayloadToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportUpdatePatientPayloadToJSON(value?: SupportUpdatePatientPayload): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'externalId': cleanupBlankValuesForBackend(value.externalId),
            'nickname': cleanupBlankValuesForBackend(value.nickname),
            'first': cleanupBlankValuesForBackend(value.first),
            'middle': cleanupBlankValuesForBackend(value.middle),
            'last': cleanupBlankValuesForBackend(value.last),
            'suffix': cleanupBlankValuesForBackend(value.suffix),
            'addresses': (value.addresses === undefined || value.addresses === null) ? undefined : (value.addresses as Array<any>).map(AddressToJSON),
            'pregnant': cleanupBlankValuesForBackend(value.pregnant),
            'dob': cleanupBlankValuesForBackend(value.dob),
            'dod': cleanupBlankValuesForBackend(value.dod),
            'sex': SexTypeToJSON(value.sex),
            'weight': cleanupBlankValuesForBackend(value.weight),
            'phones': cleanupBlankValuesForBackend(value.phones),
            'emails': cleanupBlankValuesForBackend(value.emails),
            'occupation': cleanupBlankValuesForBackend(value.occupation),
            'release': cleanupBlankValuesForBackend(value.release),
    };
}


